module.exports = __webpack_public_path__ + "static/media/forgot-pass-email-sent.a75497e5.png";